import { useEffect } from 'react';

interface SchemaOrgProps {
  data: Record<string, unknown>;
}

export default function SchemaOrg({ data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    script.setAttribute('data-schema', 'true');
    document.head.appendChild(script);

    return () => {
      const existing = document.head.querySelector('script[data-schema="true"]');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, [data]);

  return null;
}